"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountingExportQuerySchema = void 0;
const zod_1 = require("zod");
/**
 * `GET /accounting-export/preview` and `GET /accounting-export/archive` —
 * the quarterly hand-off to the accountant. Both take the same query: the
 * firm plus an inclusive date range. The range is capped at 366 days (one
 * leap year) — the archive is built in memory, and a multi-year range is
 * never what an accountant asks for.
 */
const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const MAX_RANGE_DAYS = 366;
const MS_PER_DAY = 86_400_000;
// Local copy of invoice.schema.ts's `isoDateField` (each schema file in this
// package keeps its own — see the note in subscription.schema.ts).
function isRealIsoDate(value) {
    const parsed = new Date(`${value}T00:00:00.000Z`);
    return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
}
const isoDateField = zod_1.z
    .string()
    .trim()
    .regex(ISO_DATE_REGEX, 'Data trebuie să fie în formatul YYYY-MM-DD.')
    .refine(isRealIsoDate, 'Dată invalidă.');
/** Whole days from `from` to `to` (both ISO dates, already validated). */
function daysBetween(from, to) {
    return Math.round((Date.parse(`${to}T00:00:00.000Z`) - Date.parse(`${from}T00:00:00.000Z`)) / MS_PER_DAY);
}
exports.accountingExportQuerySchema = zod_1.z
    .object({
    companyId: zod_1.z.uuid('companyId este obligatoriu și trebuie să fie un UUID valid.'),
    dateFrom: isoDateField,
    dateTo: isoDateField,
})
    // ISO dates compare correctly as strings once the regex has passed.
    .refine((query) => query.dateTo >= query.dateFrom, {
    message: 'Data de sfârșit trebuie să fie după data de început.',
    path: ['dateTo'],
})
    .refine((query) => query.dateTo < query.dateFrom || daysBetween(query.dateFrom, query.dateTo) <= MAX_RANGE_DAYS, {
    message: `Perioada nu poate depăși ${MAX_RANGE_DAYS} de zile.`,
    path: ['dateTo'],
});
